export default __webpack_public_path__ + "static/media/map.eded3ff2.png";